import React from 'react';
import {
  ArrowRightIcon,
  Box,
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';
import useFeature from 'hooks/useFeature';
import { getPeoplePage } from 'utils/links';

function CreateStructureSuccessModal({
  isOpen,
  onDismiss,
}: {
  isOpen: boolean;
  onDismiss: () => void;
}) {
  const { isEmployeeOnboardingEnabled } = useFeature('employeeOnboarding');

  const handleGoToPeoplePageCTAClick = () => {
    const url = getPeoplePage(isEmployeeOnboardingEnabled);
    window.location.href = url;
  };
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <ModalHeader />
      <ModalBody>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          textAlign={'center'}
          gap="spacing.4">
          <Heading size="2xlarge">🎉</Heading>
          <Text weight="semibold" size="large">
            Hurray! You’ve created your first structure{' '}
          </Text>

          <Text weight="regular" size="medium" color="surface.text.gray.muted">
            You can go to employee’s profile and assign it employees now
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box padding={'spacing.2'}>
          <Button
            size="medium"
            iconPosition="right"
            icon={ArrowRightIcon}
            isFullWidth
            onClick={handleGoToPeoplePageCTAClick}>
            Go to people's page
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
}

export default CreateStructureSuccessModal;
